export const SET_USERS = 'SET_USERS';
export const SET_USERS_FAILED = 'SET_USERS_FAILED';
export const SET_SUPPLIERS = 'SET_SUPPLIERS';
export const SET_SUPPLIERS_FAILED = 'SET_SUPPLIERS_FAILED';
export const SET_SUPPLIERS_LOADING = 'SET_SUPPLIERS_LOADING';
export const SET_SELECTED_SUPPLIER = 'setSelectedSupplier';
export const MATCH_USER_TO_SUPPLIER = 'SET_USERS_FAILED';
export const MATCH_DEMAND_TO_ORDER = 'matchDemandToOrder';
export const MATCH_OFFER_TO_ORDER = 'matchOfferToOrder';
// Common
export const REPLACE = 'replace';
export const FAILED = 'failed';
export const SET_PURCHASE_ORDER_DEMANDS_FAILED = 'SET_PURCHASE_ORDER_DEMANDS_FAILED';
export const SET_PURCHASE_ORDER_DEMANDS_LOADING = 'SET_PURCHASE_ORDER_DEMANDS_LOADING';
export const SET_PURCHASE_ORDER_OFFERS_FAILED = 'SET_PURCHASE_ORDER_OFFERS_FAILED';
export const SET_PURCHASE_ORDER_OFFERS_LOADING = 'SET_PURCHASE_ORDER_OFFERS_LOADING';
export const LOADING = 'loading';
export const LOADED = 'loaded';
export const CHANGE_STATE = 'CHANGE_STATE';
export const SET_STATUS = 'SET_STATUS';

// Demand
export const FULFILL_DEMAND = 'FULFILL_DEMAND';
export const REQUEST_DEMAND = 'REQUEST_DEMAND';
export const UNREQUEST_DEMAND = 'UNREQUEST_DEMAND';
export const CANCEL_DEMAND = 'CANCEL_DEMAND';
export const POPULATE_DEMANDS = 'POPULATE_DEMANDS';
export const POPULATE_DEMANDS_SKU = 'POPULATE_DEMANDS_SKU';

// PurchaseOffer
export const SET_PURCHASEOFFER_ERROR = 'SET_PURCHASEOFFER_ERROR';
export const SET_PURCHASEOFFERS = 'SET_PURCHASEOFFERS';
export const SET_PURCHASEOFFERS_STOCK = 'SET_PURCHASEOFFERS_STOCK';
